export const images = {
    logo: require('./eventox/EVENTOX_LOGO.png'),
    eventox_logo: require('./eventox/logo1.png'),
    eventox_blackLogo: require('./eventox/EVENTOX_LOGO.png'),
    defaultProfileIcon: require('./eventox/default-profile-icon.jpg'),
    calendar:require('./eventox/calendar.png'),
    ticket:require('./eventox/ticket.png'),
    noEvent:require('./eventox/no-event-placeholder.jpg'),
    standardWebinar:require('./eventox/icon/standard-webinar.png'),
    training:require('./eventox/icon/health-and-welbeing.png'),
    onlineClasses:require('./eventox/icon/e-learning.png'),
    talkShow:require('./eventox/icon/talk-show-1.png'),
    defaultEventBanner:require('./banner.jpg'),
    discount:require('./discount.png'),
    profile:require('./profile.jpg'),
    eventox_light_logo:require('./eventox/eventox_light.png'),
    eventox_dark_logo:require('./eventox/eventox_dark.png'),
    grey_logo:require('./eventox/grey_logo.png'),
    white_icon:require('./eventox/white_icon.png'),    
    learnMore:{
        isOtherAttendeeRequired:require('./learn-more/isOtherAttendeeRequired.png'),
        showOtherFees:require('./learn-more/showOtherFees.png'),
        multipleTicketGroups:require('./learn-more/multipleTicketGroups.png'),
    }

    


    
    
  
}